import React from 'react'
import { useI18N } from '../../../libraries/i18n/hook'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
}
const Checkbox:React.FC<Props> = ({ label, ...rest }) => {
  const ref = React.useRef<HTMLInputElement>(null)
  const { t } = useI18N()

  React.useEffect(() => {
    if (ref.current) {
      ref.current.setCustomValidity('')
      ref.current.oninvalid = () => {
        ref.current!.setCustomValidity(t('error.select.min.an.option'))
      }
      ref.current.oninput = () => {
        ref.current!.setCustomValidity('')
      }
    }
  }, [rest.required])
  return (
    <label
      htmlFor={rest.id}
      className={`text-2xs sm:text-sm relative w-40 sm:w-[230px] bg-white rounded-lg px-3 sm:px-4 py-4 sm:py-6 text-center ${rest.checked ? 'border border-solid border-deep-green text-deep-green' : 'shadow-md '}`}
    >
      {label}
      <input
        ref={ref}
        type='checkbox'
        className='absolute opacity-0'
        {...rest}
      />
    </label>
  )
}

export default Checkbox
